import React from 'react';
import { Sparkles, Leaf, ShieldCheck, Zap } from 'lucide-react';
export function WhyUs() {
  const features = [{
    title: 'Streak-Free Guarantee',
    description: 'We promise a perfect finish every time, or we make it right.',
    icon: Sparkles
  }, {
    title: 'Eco-Friendly Products',
    description: 'Safe for your family, pets, and plants.',
    icon: Leaf
  }, {
    title: 'Fully Licensed & Insured',
    description: 'Peace of mind knowing your property is protected.',
    icon: ShieldCheck
  }, {
    title: 'Fast & Friendly Service',
    description: 'Punctual professionals who respect your time.',
    icon: Zap
  }];
  return <section id="why-us" className="py-20 bg-white" data-id="element-149">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-150">
        <div className="text-center mb-16" data-id="element-151">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-152">
            Why Phoenix Homeowners Choose EZAZ
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-153">
            We don't just clean windows; we brighten your entire home with
            service you can trust.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12" data-id="element-154">
          {features.map((feature, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-155">
              <div className="h-16 w-16 rounded-full bg-gold/10 flex items-center justify-center mb-6 text-navy" data-id="element-156">
                <feature.icon className="h-8 w-8" data-id="element-157" />
              </div>
              <h3 className="text-lg font-bold text-navy mb-2" data-id="element-158">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-159">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}